module.exports = __webpack_public_path__ + "static/youles_logo-d322143aaaf7fa816ce8568cdbccb817.png";